import { useState } from 'react';
import { Grid, Button as MuiButton, IconButton } from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { Edit2 } from 'react-feather';
import { CellContext } from '@tanstack/react-table';
import { Product } from '@/types/menuStore.types';
import { CustomTableMeta } from '@/components/Tables/TableCard/TableCard.types';
import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';

const disableButton = (validRow: unknown, userType = '') => {
  if (userType === 'Admin') return false;
  return validRow ? Object.values(validRow)?.some((item) => !item) : false;
};

export const CellEditProduct = ({ row, table }: CellContext<Product, unknown>) => {
  const { meta } = table.options;

  const {
    index: rowIndex,
    original: { lock },
  } = row;

  const {
    setEditedRows,
    setCancelEdition,
    editedRows,
    revertData,
    data,
    onSaveItemData,
    storeNumber,
    validRows,
    userType,
  } = meta as CustomTableMeta<Product>;

  const validRow = validRows && validRows[rowIndex];
  const disableSubmit = disableButton(validRow, userType);

  const editing = !!(editedRows && editedRows[Number(row.id)]);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  return (
    <>
      {lock && (
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="end"
          spacing={2}
          pr={5}
          sx={{
            minWidth: '140px',
            minHeight: '48px',
          }}
        />
      )}
      {editing && !sent && !lock && (
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="end"
          spacing={2}
          pr={5}
          sx={{
            minWidth: '140px',
          }}
        >
          <Grid item xs={6} mb="4px">
            <Button
              variant={ButtonVariants.Text}
              onClick={() => {
                if (revertData) {
                  revertData(rowIndex, true);
                }
                if (setEditedRows) {
                  setEditedRows((old: Record<string, unknown>[]) => ({
                    ...old,
                    [row.id]: !old[Number(row.id)],
                  }));
                }
                if (setCancelEdition) {
                  setCancelEdition((old: Record<string, unknown>[]) => ({
                    ...old,
                    [row.id]: true,
                  }));
                }
              }}
            >
              Cancel
            </Button>
          </Grid>

          <Grid item xs={6} alignContent="center" alignItems="flex-end">
            <MuiButton
              variant="contained"
              color="error"
              size="small"
              disabled={disableSubmit}
              onClick={() => {
                setLoading(true);
                if (onSaveItemData) {
                  onSaveItemData(storeNumber || '', data[rowIndex]);
                }

                setLoading(false);

                setTimeout(() => {
                  setSent(false);
                }, 3000);
                setSent(true);

                if (setCancelEdition) {
                  setCancelEdition((old: Record<string, unknown>[]) => ({
                    ...old,
                    [row.id]: false,
                  }));
                }

                if (setEditedRows) {
                  setEditedRows((old: Record<string, unknown>[]) => ({
                    ...old,
                    [row.id]: !old[Number(row.id)],
                  }));
                }

                setTimeout(() => {
                  setSent(false);
                }, 3000);
              }}
              sx={{
                borderRadius: '20px',
                fontSize: '14px',
                mr: '55px',
                color: 'var(--white)',
                fontStretch: '600',
                fontFamily: 'Open Sans',
                textTransform: 'none',
                maxHeight: '48px',
              }}
            >
              {!loading ? 'Submit' : ''}
            </MuiButton>
          </Grid>
        </Grid>
      )}

      {(!editing || sent) && !lock && (
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="end"
          spacing={2}
          pr={5}
          sx={{
            minWidth: '140px',
          }}
        >
          <Grid item xs={6} mb="4px" />
          <Grid item xs={6} alignContent="center" alignItems="flex-end">
            {!sent ? (
              <IconButton
                size="small"
                color="info"
                data-testid="edit-icon"
                onClick={() => {
                  if (setEditedRows) {
                    setEditedRows((old: Record<string, unknown>[]) => ({
                      ...old,
                      [row.id]: !old[Number(row.id)],
                    }));
                  }
                }}
                sx={{
                  fontSize: '24px',
                  margin: 0,
                  marginLeft: 2,
                  maxHeight: '48px',
                }}
              >
                {/* <EditOutlinedIcon fontSize="inherit" /> */}
                {/* {!lock && <Edit2 name="" color="#266DCC" />} */}
                <Edit2 name="" color="#266DCC" />
              </IconButton>
            ) : (
              <MuiButton
                variant="contained"
                color="success"
                onClick={(e) => e.preventDefault()}
                startIcon={<TaskAltIcon />}
                size="small"
                sx={{
                  borderRadius: '20px',
                  fontSize: '14px',
                  mr: '55px',
                  color: 'var(--white)',
                  fontStretch: '600',
                  fontFamily: 'Open Sans',
                  textTransform: 'none',
                  maxHeight: '48px',
                }}
              >
                Sent
              </MuiButton>
            )}
          </Grid>
        </Grid>
      )}
    </>
  );
};
